export default {
  supplierDeliveryOrder: {
    search: {
      instructionNo: '供应商发货指令',
      instructionNolist: '发货指令编号',
      instructionNoPlaceholder: '请输入供应商发货指令',
      deliverMethod: '发货方式',
      deliverMethodPlaceholder: '请选择发货方式',
      deliverMethodOptionOne: '供应商配送',
      deliverMethodOptionTwo: '物产自提',
      deliverMethodOptionThree: '客户自提',
      deliverMethodOptionFour: '库转',
      directDeliver: '是否直拨',
      isDirectDeliverPlaceholder: '请选择是否直拨',
      isDirectDeliverOptionOne: '直拨',
      isDirectDeliverOptionTwo: '非直拨',
      partnerNo: '供应商',
      partnerNamePlaceholder: '请选择供应商',
      purchaseContractNo: '采购合同号',
      purchaseContractNoPlaceholder: '请输入采购合同号',
      instructionStatus: '发货指令状态',
      instructionStatusPlaceholder: '请选择发货指令状态',
      instructionStatusOptionOne: '已保存',
      instructionStatusOptionTwo: '已提交物流', //已确认
      instructionStatusOptionThree: '已业务入库',
      instructionCreateStartDate: '创建开始日期',
      instructionCreateEndDate: '创建截止日期',
      expectArrivalStartDate: '预计到货开始日期',
      expectArrivalEndDate: '预计到货截至日期',
      deliverStartDate: '发货开始日期',
      deliverEndDate: '发货截至日期',
      companyName: '公司',
      storageName: '仓库',
      companyNamePlaceholder: '请输入公司',
      distributionMode: '运输方式',
      distributionModePlaceholder: '请选择运输方式',
      distributionModeOptionOne: '公路',
      distributionModeOptionTwo: '铁路',
      distributionModeOptionThree: '快件',
      distributionModeOptionFour: '水路运',
      distributionModeOptionFive: '空运',
      purchaseIntentNo: '意向单号',
      purchaseIntentNoPlaceholder: '请输入意向单号',
      departmentName: '部门',
      departmentNamePlaceholder: '请选择部门',
      salesmanName: '业务员',
      salesmanNamePlaceholder: '请选择业务员',
      createPersonName: '制单人',
      createPersonNamePlaceholder: '请选择制单人',
      goodDesc: '商品',
      goodDescPlaceholder: '请选择商品',
      externalContractNo: '外部合同号',
      externalContractNoPlaceholder: '请输入外部合同号',
    },
    table: {
      partnerName: '供应商名称',
      deliverFromAddress: '发出地点',
      instructionCreateDate: '创建日期',
      productDesc: '商品描述',
      unit: '单位',
      instructionNumber: '供应商发货指令数量',
      contractNo: '采购合同数量',
      deliverDate: '发货日期',
      expectArrivalDate: '预计到货日期',
      mark: '备注',
      userAcct: '用户账号',
      sex: '性别',
      phone: '手机号码',
      gmtCreate: '创建时间',
      gmtModified: '修改时间',
      remark: '备注',
      inboundQuantity: '物流已入库数量',
      businessInboundQuantity: '已业务入库数量',
    },
    button: {
      reference: '引用采购合同创建',
    },
    message: {
      leastMsg: '请勾选至少一条数据',
    },
    title: {
      addSupplierDelivery: '创建供应商发货指令',
    },
    creatDialog: {
      search: {
        contractNo: '采购合同号',
        externalContractNo: '外部合同号',
        intentionNo: '意向单号',
        productNo: '商品',
        contractSalesmanNo: '业务员',
        contractBusinessDepartment: '部门',
        supplierNo: '供应商',
        remaindThanZero: '不看剩余为零',
      },
      table: {
        contractNo: '采购合同号',
        externalContractNo: '外部合同号',
        intentionNo: '意向单号',
        supplierName: '供应商名称',
        storageName: '仓库',
        deliverTypeName: '发货方式',
        productDesc: '商品描述',
        unit: '单位',
        productQuantity: '采购合同数量',
        contractSalesmanName: '业务员',
        contractBusinessDepartmentName: '部门',
        companyName: '公司',
        deliverableQuantity: '剩余可发数量',
      },
      title: {
        create: '引用采购合同创建供应商发货指令',
      },
    },
    msg: {
      copyContractTips: '请选择一条供应商发货指令',
      purchaseContractTips: '请选择采购合同进行操作',
      selectGoods: '请选择同一个合同或者意向单进行操作',
      selectstorageDeliver: '选中的项目仓库和交货方式不一致',
      directDeliverTips: '请选择一条已保存或已业务入库的供应商发货指令',
      notDirectDeliverTips: '请选择一条已保存或已提交物流的供应商发货指令', //已确认
    },
  },
};
